"use strict";

var _primarySwatches, _secondarySwatches, _greySwatches;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = {
  colors: {
    primarySwatches: (_primarySwatches = {}, _defineProperty(_primarySwatches, 900, '#005A98'), _defineProperty(_primarySwatches, 800, '#007ABA'), _defineProperty(_primarySwatches, 700, '#008BCE'), _defineProperty(_primarySwatches, 600, '#069EE1'), _defineProperty(_primarySwatches, 500, '#0CACF0'), _defineProperty(_primarySwatches, 400, '#2EB9F2'), _defineProperty(_primarySwatches, 300, '#52C5F3'), _defineProperty(_primarySwatches, 200, '#82D6F7'), _defineProperty(_primarySwatches, 100, '#B4E6FA'), _defineProperty(_primarySwatches, 50, '#E1F5FD'), _primarySwatches),
    secondarySwatches: (_secondarySwatches = {}, _defineProperty(_secondarySwatches, 900, '#2A2A2A'), _defineProperty(_secondarySwatches, 800, '#4C4C4C'), _defineProperty(_secondarySwatches, 700, '#6C6C6C'), _defineProperty(_secondarySwatches, 600, '#808080'), _defineProperty(_secondarySwatches, 500, '#AAAAAA'), _defineProperty(_secondarySwatches, 400, '#C8C8C8'), _defineProperty(_secondarySwatches, 300, '#EAEAEA'), _defineProperty(_secondarySwatches, 200, '#F2F2F2'), _defineProperty(_secondarySwatches, 100, '#F7F7F7'), _defineProperty(_secondarySwatches, 50, '#FCFCFC'), _secondarySwatches),
    greySwatches: (_greySwatches = {}, _defineProperty(_greySwatches, 900, '#2E2E2E'), _defineProperty(_greySwatches, 800, '#4C4C4C'), _defineProperty(_greySwatches, 700, '#636363'), _defineProperty(_greySwatches, 600, '#757575'), _defineProperty(_greySwatches, 500, '#8E8E8E'), _defineProperty(_greySwatches, 400, '#A6A6A6'), _defineProperty(_greySwatches, 300, '#BDBDBD'), _defineProperty(_greySwatches, 200, '#CDCDCD'), _defineProperty(_greySwatches, 100, '#D7D7D7'), _defineProperty(_greySwatches, 50, '#E1E1E1'), _defineProperty(_greySwatches, 20, '#EBEBEB'), _defineProperty(_greySwatches, 10, '#F5F5F5'), _greySwatches),
    green: '#00B400',
    yellow: '#FFD200',
    orange: '#FF8000',
    red: '#ED1C24',
    black: '#000000',
    white: '#FFFFFF'
  },
  shadow: {
    primaryShadow: '0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2)'
  },
  typography: {
    body: {
      size: 16,
      lineheight: 18,
      fontface: "Proxima-Nova",
      weight: "Regular"
    },
    title: {
      size: 20,
      lineheight: 24,
      fontface: "Proxima-Nova",
      weight: "Medium"
    },
    buttons: {
      size: 14,
      lineheight: 26,
      fontface: "Proxima-Nova",
      weight: "Medium"
    }
  }
};